import React, { useState } from "react";
import "./Tab_list.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faChevronDown,
  faChevronRight,
  faCopy,
} from "@fortawesome/free-solid-svg-icons";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import Confirm_Modal from "../Common_Modal/Confirm_Modal/Confirm_Modal";
import Congratulation_Modal from "../Common_Modal/Congratulation_Modal/Congratulation_Modal";
import Cancel_Transaction from "../Common_Modal/Cancel_Transaction/Cancel_Transaction";
import Order_Not_Completed_Modal from "../Common_Modal/Order_Not_Completed_Modal/Order_Not_Completed_Modal";

function Tab_list({ listItems = [], promotionData }) {
  const [open, setOpen] = useState(false);
  const [modalShow, setModalShow] = React.useState(false);
  const navigate = useNavigate();

  const handleLogout = () => {
    setModalShow(true);
  };
  const [copied, setCopied] = useState(false);

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <>
      <section className="Tab_list">
        <div className="tab_list">
          {listItems.map((item, index) => (
            <Link key={index} to={item.link || "#"}>
              <div className="list-item">
                <div className="list_name_holder">
                  <div className="icon_img_holder">
                    <img
                      src={item.image}
                      className="icon_img"
                      alt={item.name}
                    />
                  </div>
                  <span>{item.name}</span>
                </div>

                <span className="details_holder">
                  {item.type === "copy" ? (
                    <>
                      <span onClick={() => handleCopy(item.value)} style={{ cursor: "pointer" }}>
                        {item.value}
                        <FontAwesomeIcon
                          icon={copied ? faCheck : faCopy}
                          className="ms-3"
                          style={{ color: copied ? "#37BB80" : "" }}
                        />
                      </span>
                    </>
                  ) : item.type === "text" ? (<></>) : (
                    <FontAwesomeIcon icon={faChevronRight} />
                  )}
                </span>
              </div>
            </Link>
          ))}

          {/* Promotion Data Collapsible */}
          {promotionData && (
            <div className="Rebate_Ratio_list_holder">
              <div className="list-item mb-0">
                <div className="list_name_holder">
                  <div className="icon_img_holder">
                    <img
                      src={promotionData.image}
                      className="icon_img"
                      alt={promotionData.title}
                    />
                  </div>
                  <span>{promotionData.title}</span>
                </div>

                <span
                  className="details_holder"
                  onClick={() => setOpen(!open)}
                  style={{ cursor: "pointer" }}
                >
                  <FontAwesomeIcon
                    icon={open ? faChevronDown : faChevronRight}
                  />
                </span>
              </div>

              <div className={`Rebate_Ratio_holder ${open ? "open" : ""}`}>
                <div className="row">
                  {promotionData.stats.map((stat, index) => (
                    <div
                      key={index}
                      className={`col-6 ${index % 2 === 0 ? "border_col" : ""}`}
                    >
                      <div className="text_holder">
                        <h3>{stat.value}</h3>
                        <p>{stat.label}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* <Button
            className="btn-register my-5"
            onClick={handleLogout}


          >
            Log out
          </Button> */}
        </div>
      </section>

      <Confirm_Modal show={modalShow} onHide={() => setModalShow(false)} />
    </>
  );
}

export default Tab_list;
